import { render, staticRenderFns } from "./login-authorization.vue?vue&type=template&id=e93f1814&"
import script from "./login-authorization.vue?vue&type=script&lang=js&"
export * from "./login-authorization.vue?vue&type=script&lang=js&"
import style0 from "./login-authorization.vue?vue&type=style&index=0&id=e93f1814&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports